import React, {Component} from 'react';
import line from '../../assets/q.png';
import api from '../../utils/api';
import PieChart from 'react-minimal-pie-chart';
import { NotificationManager } from 'react-notifications';

class FinalQuiz extends Component {
    state = {
        currentQuestionIndex: 0,
        currentAnswer: '',
        answers: [],
        finished: false,
        started: false,
        results: this.props.results,
        retakingTest: false,
        questionTime: 0,
        questionTimer: null
    };

    updateQuestionTimer = () => {
        this.setState({questionTime: this.state.questionTime + 1})
    }

    setNextQuestion = () => {
        let {answers} = this.state;
        let canAdd = true;
        answers.map(a => {
            if(a.quizQuestionId.id === this.props.questions[this.props.quiz.currentQuestion].id){
                canAdd = false;
                if(this.state.currentAnswer){
                    a.answer = this.state.currentAnswer
                }
            }
        })

        if(canAdd){
            answers.push({
                quizQuestionId: this.props.questions[this.props.quiz.currentQuestion],
                answer: this.state.currentAnswer,
                time: this.state.questionTime

            });

        }

        this.setState({
            currentQuestionIndex: this.props.quiz.currentQuestion + 1,
            answers,
            currentAnswer: '',
            questionTime: 0,
            finished: (this.props.quiz.currentQuestion + 1 == this.props.questions.length)
        });


    }

    goToNextQuestion = () => {

        let question = {
            quizQuestionId: this.props.questions[this.props.quiz.currentQuestion],
            answer: this.state.currentAnswer,
            time: this.state.questionTime
        };

        this.props.updateQuiz(question, "add");
    }

    addAnswer = (answer) => {
        let {answers, currentAnswer} = this.state;
        let canAdd = true;
        currentAnswer = answer;

        this.setState({
            currentAnswer
        });

    }

    componentWillUpdate(props, state){
        if(props.results != this.state.results && !this.state.retakingTest){
            this.setState({results: props.results});
        }

        if(state.finished && state.questionTimer && this.props.quiz.completed){
            clearInterval(state.questionTimer);
        }

    }

    componentDidUpdate(props, state){
        if (this.props.quiz) {
            if (!this.state.started && this.props.quiz.id) {
                let questionTimer = setInterval(this.updateQuestionTimer, 1000);
                this.setState({started: true, questionTime: 0, questionTimer: questionTimer});
                if (this.props.quiz.answers[this.props.quiz.currentQuestion]) {
                    // Has already answered this question, reset
                    this.setState({
                        started: true,
                        questionTimer: questionTimer,
                        currentQuestionIndex: this.props.quiz.currentQuestion + 1,
                        currentAnswer: this.props.quiz.answers[this.props.quiz.currentQuestion].answer,
                        questionTime: this.props.quiz.answers[this.props.quiz.currentQuestion].time
                    });
                } else {

                    this.setState({
                        currentQuestionIndex: this.props.quiz.currentQuestion + 1,
                        currentAnswer: '',
                        questionTime: 0
                    });
                }
            }else if (props.quiz.currentQuestion !== this.props.quiz.currentQuestion) {
                if (this.props.quiz.answers[this.props.quiz.currentQuestion]) {
                    // Has already answered this question, reset
                    this.setState({
                        currentQuestionIndex: this.props.quiz.currentQuestion + 1,
                        currentAnswer: this.props.quiz.answers[this.props.quiz.currentQuestion].answer,
                        questionTime: this.props.quiz.answers[this.props.quiz.currentQuestion].time
                    });
                } else {

                    this.setState({
                        currentQuestionIndex: this.props.quiz.currentQuestion + 1,
                        currentAnswer: '',
                        questionTime: 0
                    });
                }
            }

            if (this.props.quiz.id && this.props.questions) {
                if (this.props.questions.length === this.props.quiz.answers.length && !this.state.finished) {
                    this.setState({
                        finished: true
                    })
                }
            }
        }

    }

    renderResults = () => {

        return (
            <div className="FinalAnswerToMCQ sp-20">
                <div className="clearfix">
                    <div className="pull-left">
                        <p className="font-30 font-300 sm-bottom30">Lecture Quiz Result</p>
                    </div>

                    {/*<div className="pull-right">
                        <a onClick={(e) => {
                            this.setState({
                                results: {},
                                retakingTest: true,
                                currentQuestionIndex: 0,
                                currentAnswer: '',
                                answers: [],
                                finished: false,
                                started: false
                            })
                        }}
                           className="btn btn-outline" ><i className="zmdi zmdi-refresh"></i> Retake Quiz </a>
                    </div>*/}
                </div>
                <div className="row">
                    <div className="col-sm-3">
                        <p className="no-margin">Correct</p>
                        <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="80">{this.props.quiz.correctAnswers}</p>
                    </div>
                    <div className="col-sm-3">
                        <p className="no-margin">Incorrect</p>
                        <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">{this.props.quiz.totalQuestions - this.props.quiz.correctAnswers}</p>
                    </div>
                    <div className="col-sm-3">
                    </div>



                    <div className="col-sm-3">
                        <div className="video-question-summary">
                            <PieChart
                                style={{width: 80, margin: '0 auto'}}
                                data={[
                                    {value: this.props.quiz.correctPercent, color: '#555'},
                                    {value: 100, color: '#e33339'}
                                ]}
                                totalValue={100}
                                lineWidth={10}
                                rounded={true}
                            />
                            <p className="diagnostic-pie-chart-counter quiz-results-pie">{this.props.quiz.correctPercent}%</p>
                        </div>

                    </div>
                </div>
                <p className="font-30 roboto font-300 sm-top-bottom50">Final Result:
                    {this.props.quiz.correctPercent >= 80 ?
                        <span className="text-success"> {this.props.quiz.correctPercent >= 100 ? 'Perfect!' : 'Pass' }</span>
                        :
                        <span className="text-danger"> Failed</span>}

                </p>


                {this.props.quiz.correctPercent < 80 &&
                <p className="font-30 roboto font-300 sm-top-bottom50">
                    You can not move forward in this course until you pass this quiz.  We're resetting the state of this lecture.  When you're ready to try again click Continue.<br />
                    <button className="btn btn-danger" onClick={(e) => {
                        window.location.href = window.location.href;
                    }
                    }>Do it again!</button>
                </p>
                }

                <table className="table">
                    <tbody>
                    <tr>
                        <th className="text-center" style={{width: 50}}>Result</th>
                        <th className="text-left">Question</th>
                        <th className="text-center" style={{width: 122}}>Time Taken</th>
                    </tr>
                    {
                        this.props.quiz.answers &&
                        this.props.quiz.answers.map((a, i) => {
                            let seconds = parseInt(a.time % 60);
                            let timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                : parseInt(a.time / 60) + ":" + seconds.toString();
                            return (
                                <tr key={i}>
                                    <td className="text-center"><i className={(a.correct) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                    <td className="text-left">
                                        <p className="font-14" dangerouslySetInnerHTML={{__html: a.quizQuestionId.question}}></p>
                                    </td>
                                    <td className="text-center">{timer}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        )
    }

    scoreTest = () => {
        let userTest = {
            userId: this.props.user.userId,
            profileId: this.props.user.user.Profile.id,
            chapterVideoId: this.props.chapterPart.id,
            answers: this.state.answers,
            courseUserId: this.props.courseUser.id,
            userLectureId: this.props.userLecture.id
        }

        this.setState({retakingTest: false});
        this.props.scoreTest(userTest);
    }


    renderQuizBody = (options, letters) => {
        let dontKnow = false;
        if(this.state.currentAnswer){
            if(this.state.currentAnswer === 5){
                dontKnow = true;
            }
        }else if(this.props.quiz.answers.length - 1 >= this.props.quiz.currentQuestion ){
            if(this.props.quiz.answers[this.props.quiz.currentQuestion].answer === 5){
                dontKnow = true;
            }
        }
        return (
            <div className="LectureQuiz question sp-20 active-question"
                 data-question="1"
                 id="FinalQuizQuestion1">
                <div className="sm-top-bottom20 text-center">
                    {(this.props.questions[this.props.quiz.currentQuestion].image) &&
                    <img src={line} alt="line"/>
                    }

                </div>
                <div className="font-18" dangerouslySetInnerHTML={{__html: this.props.questions[this.props.quiz.currentQuestion].question}}>

                </div>
                {this.props.questions[this.props.quiz.currentQuestion].File.length > 0 &&
                this.props.questions[this.props.quiz.currentQuestion].File.map((file, fi) => {
                    return (
                        <img key={fi} src={api.makeFileURL(file.url, this.props.user.id)} className="quiz-image" />
                    )
                })
                }
                <ul className="list-unstyled mcqList no-padding">
                    {options.map((option, index) => {
                        if(this.props.questions[this.props.quiz.currentQuestion]["option" + letters[option]]) {
                            let checked = false;
                            if(this.state.currentAnswer){
                                if(this.state.currentAnswer === option){
                                    checked = true;
                                }
                            }else if(this.props.quiz.answers.length - 1 >= this.props.quiz.currentQuestion ){
                                if(this.props.quiz.answers[this.props.quiz.currentQuestion].answer === option){
                                    checked = true;
                                }
                            }

                            return (
                                <li className="no-padding" key={index}>
                                    <div
                                        className={`iradio_square video-modal-radio-wrapper quiz-option ${checked && 'checked'}`}
                                    >
                                        <input
                                            type="radio"
                                            name="radio"
                                            value={this.props.questions[this.props.quiz.currentQuestion]["option" + letters[option]]}
                                            className='video-modal-radio'
                                            onClick={() => this.addAnswer(option)}
                                        />
                                        <ins className="iCheck-helper video-modal-radio-icon"/>
                                    </div>
                                    <div className="video-answer" onClick={() => this.addAnswer(option)} dangerouslySetInnerHTML={{__html: this.props.questions[this.props.quiz.currentQuestion]["option" + letters[option]]}}></div>
                                </li>
                            )

                            /*
                             LEGACY UI

                            return (
                                <li key={index}>
                                    <label>
                                        <input type="radio"
                                               name="radio"
                                               checked={checked}
                                               onChange={(e) => this.addAnswer(option)}
                                               value={this.props.questions[this.props.quiz.currentQuestion]["option" + letters[option]]}/>
                                        <div className="video-answer" dangerouslySetInnerHTML={{__html: this.props.questions[this.props.quiz.currentQuestion]["option" + letters[option]]}}></div>
                                    </label>
                                </li>
                            )

                             */
                        }
                    })}

                    <li className="no-padding">
                        <div
                            className={`iradio_square video-modal-radio-wrapper quiz-option ${dontKnow && 'checked'}`}
                        >
                            <input
                                type="radio"
                                name="radio"
                                value={5}
                                className='video-modal-radio'
                                onClick={() => this.addAnswer(5)}
                            />
                            <ins className="iCheck-helper video-modal-radio-icon"/>
                        </div>
                        <div className="video-answer" onClick={() => this.addAnswer(5)}><p>I’m not sure. (It’s better that I don’t pick an answer.)</p></div>
                    </li>


                </ul>
            </div>
        )
    }

    goToPreviousQuestion = () => {
        if (this.props.quiz.currentQuestion >= this.props.questions.length) {
            this.props.updateCurrentQuestion("subtract", this.state.questionTime);
        } else {
            let question = {
                quizQuestionId: this.props.questions[this.props.quiz.currentQuestion],
                answer: this.state.currentAnswer,
                time: this.state.questionTime
            };

            this.props.updateQuiz(question, "subtract");
        }
    }




    renderQuizFooter = () => (
        <div className="sp-20">
            <div className="row">
                <div className="col-xs-6">
                    <div className=" final-mcqs-controls">
                        {(this.props.quiz.currentQuestion > 0) &&
                        <button
                            onClick={(e) => this.goToPreviousQuestion()}
                            className="btn btn-default"
                        >
                            <i className={"zmdi zmdi-arrow-left"} /> &nbsp;
                            Previous Question
                        </button>
                        }

                        {this.props.quiz.currentQuestion < this.props.questions.length ?
                            <button
                                onClick={(e) => {
                                    const {currentAnswer, answers} = this.state;
                                    let currentQuestionIndex = this.props.quiz.currentQuestion;
                                    let answered = false;
                                    if(currentAnswer){
                                        answered = true;
                                    }

                                    if(this.props.quiz.answers.length - 1 >= currentQuestionIndex){
                                        if(this.props.quiz.answers[currentQuestionIndex].answer){
                                            answered = true;
                                        }
                                    }
                                    if(answered){
                                        this.goToNextQuestion();
                                    }else{
                                        NotificationManager.error('You need to answer this question before proceeding');
                                    }

                                }}
                                className="btn btn-danger"
                            >

                                Next Question &nbsp;
                                <i className={"zmdi zmdi-arrow-right"} />
                            </button>
                        : null}

                        {this.state.finished && this.props.quiz.currentQuestion < this.props.questions.length ?
                            <button
                                onClick={(e) => this.scoreTest()}
                                className="btn btn-danger"
                            >
                                <i className={"zmdi zmdi-check"} /> &nbsp;
                                Score Quiz
                            </button>
                            :
                            null
                        }

                    </div>
                </div>
                <div className="col-xs-6">
                    {this.renderQuestionTime()}
                </div>
            </div>
        </div>
    );

    renderQuestionTime = () => {
        let seconds = parseInt(this.state.questionTime % 60);
        let timer = (seconds < 10) ? parseInt(this.state.questionTime / 60) + ":" + "0" + seconds.toString()
            : parseInt(this.state.questionTime / 60) + ":" + seconds.toString();

        if (this.props.quiz && this.props.questions) {
            if (!this.props.quiz.completed || this.props.quiz.currentQuestion < this.props.questions.length) {
                return (
                    <div className="FinalQuizTimer text-right">{timer}</div>
                )
            }
        }
    }

    startQuiz = () => {
        if(this.props.quiz) {
            if (this.props.quiz.userLectureId === this.props.userLecture.id) {
                let questionTimer = setInterval(this.updateQuestionTimer, 1000);
                this.setState({started: true, questionTime: 0, questionTimer: questionTimer});
            }
        }
        this.props.getOrCreate();
    }

    renderQuestionCount = () => {
        let cc = (this.props.quiz.currentQuestion + 1 > this.props.questions.length) ? this.props.questions.length : this.props.quiz.currentQuestion + 1;
        let progress = Math.ceil(((this.props.quiz.answers.length + 1) / this.props.questions.length) * 100);
        return (
            <div className="pull-right">
                <div className="video-question-summary quiz-question-counter">
                    <PieChart
                        style={{width: 64, margin: '0 auto'}}
                        data={[
                            {value: 100, color: '#555'},
                            {value: progress, color: '#e33339'}
                        ]}
                        totalValue={100}
                        startAngle={-90}
                        lineWidth={10}
                        rounded={true}
                    />
                    <p className="diagnostic-pie-chart-counter">{cc} / {this.props.questions.length}</p>
                </div>
            </div>
        )
    }

    renderPreSubmit = () => {
        return (
            <div className={"end-of-test"}>
                <p className="font-24 text-white">
                    You've reached the end of the quiz!
                </p>
                <p>
                    Before submitting your quiz for scoring, you can navigate back through your quiz and double check your answers.
                </p>
                <button
                    onClick={(e) => this.scoreTest()}
                    className="btn btn-danger btn-lg"
                >
                    <i className={"zmdi zmdi-check"} /> &nbsp;
                    Score My Quiz
                </button>
            </div>
        )
    }

    render() {
        let options = [1, 2, 3, 4];
        let optionLetters = ["", "A", "B", "C", "D"];


        if(this.props.quiz.completed){
            return (
                <div className="question sp-20 active-question" data-question="0" id="FinalQuizQuestion0">
                    {this.renderResults()}
                </div>
            )
        }else
        if(this.state.started) {
            return (
                <div className="final_quiz_list">
                    {this.renderQuestionCount()}

                    {
                        this.props.quiz.currentQuestion + 1 <= this.props.questions.length &&
                        this.renderQuizBody(options, optionLetters)}

                    {this.state.finished && !this.props.quiz.completed && this.props.quiz.currentQuestion >= this.props.questions.length ?
                        this.renderPreSubmit()
                        : null}
                    <hr className="no-margin" />
                    {this.renderQuizFooter()}
                </div>
            )
        }
        else{
            return (
                <div className="LectureQuiz question sp-20 active-question" data-question="0" id="FinalQuizQuestion0">

                    <div className="sp-top-bottom30 text-center">
                        <p className="sm-top0 instructionsQuiz">

                            Instructions: You need AT LEAST 80% on the following quiz to move on to the next lecture. Unfortunately, You will have to repeat the entire lecture again, if you score below this bar. <br /><br />

                            We would advise that you iron out your understanding before proceeding.
                        </p>
                        <div className="sm-top30 text-right">
                            <button className="btn btn-danger btn-lg" onClick={e => this.startQuiz()}>Start Quiz</button>
                        </div>
                    </div>

                </div>
            )
        }
    }
}

export default FinalQuiz;


// WEBPACK FOOTER //
// ./src/components/Video/FinalQuiz.js